<template>
    <div style="text-align:left">
        <Breadcrumb style="margin: 0px 10px 20px">
            <BreadcrumbItem to="/adAdmin">广告管理</BreadcrumbItem>
            <BreadcrumbItem>广告详情</BreadcrumbItem>
        </Breadcrumb>
        <Card>
            <Row type="flex" class="row">
                <Col span="6" class="col1" >广告id</Col>
                <Col span="12">{{ad_id}}</Col>
            </Row>
            <Row type="flex" class="row">
                <Col span="6" class="col1" >广告来源</Col>
                <Col span="12">{{source}}</Col>
            </Row>
            <Row type="flex" class="row">
                <Col span="6" class="col1" >广告类型</Col>
                <Col span="12">
                    <span v-if="ad_content_type == 0">无</span>
                    <span v-if="ad_content_type == 1">营收业务</span>
                    <span v-if="ad_content_type == 2">主推活动</span>
                    <span v-if="ad_content_type == 3">常规活动</span>
                    <span v-if="ad_content_type == 4">会员宣导</span>
                    <span v-if="ad_content_type == 5">用户运营</span>
                </Col>
            </Row>
            <div v-if="source=='自营广告' || source=='图片弹窗广告'">
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >广告样式</Col>
                    <Col span="12">横板大图</Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >广告名称</Col>
                    <Col span="12">{{title}}</Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >素材类型</Col>
                    <Col span="12">
                        <span v-if="material_type == 1">图片</span>
                        <span v-if="material_type == 2">视频</span>
                        <span v-if="material_type == 3">纯文本</span>
                    </Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >广告图</Col>
                    <Col span="12">
                        <div>
                            <img :src='material_url' v-if="material_type == 1" style="max-height:200px;max-width:300px">
                            <video :src="material_url" v-if="material_type == 2" controls="controls" style="max-height:200px;max-width:300px"/>
                        </div>
                    </Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >文案描述</Col>
                    <Col span="12">{{content}}</Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >button名称</Col>
                    <Col span="12">{{button_name}}</Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >跳转链接</Col>
                    <Col span="12">{{jump_link}}</Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >跳转类型</Col>
                    <Col span="12">
                        <span v-if="jump_type == 1">内部H5跳转</span>
                        <span v-else-if="jump_type == 2">APP原生页面</span>
                        <span v-else-if="jump_type == 3">系统浏览器外部链接</span>
                    </Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >广告频率</Col>
                    <Col span="12">
                        <span v-if="frequency == 1">每次打开</span>
                        <span v-else-if="frequency == 2">每天一次</span>
                        <span v-else-if="frequency == 3">每周一次</span>
                        <span v-else-if="frequency == 4">每月一次</span>
                        <span v-else-if="frequency == 5">只弹一次</span>
                        <span v-else-if="frequency == 6">三天一次</span>
                        <span v-else-if="frequency == 7">每日弹1次，共弹2次</span>
                        <span v-else-if="frequency == 8">点击一次后不再投放</span>
                    </Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >广告时长</Col>
                    <Col span="12">
                        <span v-if="duration == 0">不限</span>
                        <span v-else>{{duration}}秒</span>
                    </Col>
                </Row>
            </div>
            <div v-if="source=='第三方广告'">
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >广告参数</Col>
                    <Col span="12">{{contents}}
                    </Col>
                </Row>
            </div>
            <div v-if="source=='商品广告'">
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >广告样式</Col>
                    <Col span="12">横板大图</Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >广告名称</Col>
                    <Col span="12">{{title}}</Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >素材类型</Col>
                    <Col span="12">
                        <span v-if="material_type == 1">图片</span>
                        <span v-if="material_type == 2">视频</span>
                        <span v-if="material_type == 3">纯文本</span>
                    </Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >广告图</Col>
                    <Col span="12">
                        <div>
                            <img :src='material_url' v-if="material_type == 1" style="max-height:200px;max-width:300px">
                            <video :src="material_url" v-if="material_type == 2" controls="controls" style="max-height:200px;max-width:300px"/>
                        </div>
                    </Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >商品描述</Col>
                    <Col span="12">{{content}}</Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >商品渠道来源</Col>
                    <Col span="12">
                        <span v-if="product_source == 1">淘宝</span>
                        <span v-else-if="product_source == 2">天猫</span>
                        <span v-else-if="product_source == 3">京东</span>
                        <span v-else-if="product_source == 4">拼多多</span>
                        <span v-else-if="product_source == 5">轻牛专属</span>
                    </Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >付款价格</Col>
                    <Col span="12">{{final_price}}</Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >优惠券</Col>
                    <Col span="12">{{coupon_amount}}</Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >原价</Col>
                    <Col span="12">{{price}}</Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >优先级</Col>
                    <Col span="12">{{rank}}</Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >跳转链接</Col>
                    <Col span="12">{{jump_link}}</Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >跳转类型</Col>
                    <Col span="12">
                        <span v-if="jump_type == 1">内部H5跳转</span>
                        <span v-else-if="jump_type == 2">APP原生页面</span>
                        <span v-else-if="jump_type == 3">系统浏览器外部链接</span>
                    </Col>
                </Row>
            </div>
            <div v-if="source=='文案弹窗广告'">
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >广告名称</Col>
                    <Col span="12">{{title}}</Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >弹窗标题</Col>
                    <Col span="12">{{popup_title}}</Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >弹窗内容</Col>
                    <Col span="12">{{content}}</Col>
                </Row>
                <Divider />
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >Button1名称</Col>
                    <Col span="12">{{buttons[0].button_name}}</Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >是否支持跳转</Col>
                    <Col span="12">
                        <span v-if="buttons[0].jump_flag == 1">是</span>
                        <span v-else>否</span>
                    </Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >Button1跳转链接</Col>
                    <Col span="12">{{buttons[0].jump_link}}</Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >Button1跳转类型</Col>
                    <Col span="12">
                        <span v-if="buttons[0].jump_type == 1">内部H5跳转</span>
                        <span v-else-if="buttons[0].jump_type == 2">APP原生页面</span>
                        <span v-else-if="buttons[0].jump_type == 3">系统浏览器外部链接</span>
                    </Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >来源</Col>
                    <Col span="12">
                        <span v-if="buttons[0].product_source == 1">淘宝</span>
                        <span v-else-if="buttons[0].product_source == 2">天猫</span>
                        <span v-else-if="buttons[0].product_source == 3">京东</span>
                        <span v-else-if="buttons[0].product_source == 4">拼多多</span>
                        <span v-else-if="buttons[0].product_source == 5">轻牛专属</span>
                    </Col>
                </Row>
                <Divider />
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >Button2名称</Col>
                    <Col span="12">{{buttons[1].button_name}}</Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >是否支持跳转</Col>
                    <Col span="12">
                        <span v-if="buttons[1].jump_flag == 1">是</span>
                        <span v-else>否</span>
                    </Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >Button2跳转链接</Col>
                    <Col span="12">{{buttons[1].jump_link}}</Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >Button2跳转类型</Col>
                    <Col span="12">
                        <span v-if="buttons[1].jump_type == 1">内部H5跳转</span>
                        <span v-else-if="buttons[1].jump_type == 2">APP原生页面</span>
                        <span v-else-if="buttons[1].jump_type == 3">系统浏览器外部链接</span>
                    </Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >来源</Col>
                    <Col span="12">
                        <span v-if="buttons[1].product_source == 1">淘宝</span>
                        <span v-else-if="buttons[1].product_source == 2">天猫</span>
                        <span v-else-if="buttons[1].product_source == 3">京东</span>
                        <span v-else-if="buttons[1].product_source == 4">拼多多</span>
                        <span v-else-if="buttons[1].product_source == 5">轻牛专属</span>
                    </Col>
                </Row>
                <Divider />
            </div>
            <div v-if="source!='第三方广告'">
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >是否订单引流</Col>
                    <Col span="12">
                        <span v-if="order_flow_flag == 1">是</span>
                        <span v-else>否</span>
                    </Col>
                </Row>
                <Row type="flex" class="row">
                    <Col span="6" class="col1" >是否会员引流</Col>
                    <Col span="12">
                        <span v-if="vip_flow_flag == 1">是</span>
                        <span v-else>否</span>
                    </Col>
                </Row>
            </div>
            <Row type="flex" class="row">
                <Col span="6" class="col1" >创建者</Col>
                <Col span="12">{{user_name}}</Col>
            </Row>
            <Row type="flex" class="row">
                <Col span="6" class="col1" >创建时间</Col>
                <Col span="12">{{created_at}}</Col>
            </Row>
        </Card>
    </div>
</template>
<script>
import{adDetail}from "@/request/api"
import Cookies from 'js-cookie';
export default {
    name: 'adDetail',
    meta:{},
    data() {
        return {
            ad_id: '',
            source: '',
            template_id: 1,
            title: '',
            material_url: '',
            content: '',
            button_name: '',
            jump_link: '',
            jump_type: '',
            user_name: '',
            created_at: '',
            uploading:false,
            material_type: 1,
            contents: "",
            user_name: "",
            created_at: "",
            product_source: 1,
            rank: 0,
            coupon_amount: 0,
            price: 0,
            final_price: 0,
            frequency: 1,
            duration: 0,
            order_flow_flag: 0,
            vip_flow_flag: 0,
            buttons: [],
            ad_content_type: 0,
        };
    },
    methods: {
        getAdDetail(ad_id=''){
            adDetail({ad_id}).then(res=>{
                if(res.data.code==200){
                    this.source = res.data.data.advertisement.source
                    this.template_id = res.data.data.advertisement.template_id
                    this.title = res.data.data.advertisement.title
                    this.material_url = res.data.data.advertisement.material_url
                    this.content = res.data.data.advertisement.content
                    this.button_name = res.data.data.advertisement.button_name
                    this.jump_link = res.data.data.advertisement.jump_link
                    this.jump_type = res.data.data.advertisement.jump_type
                    this.material_type = res.data.data.advertisement.material_type
                    this.contents = res.data.data.advertisement.content
                    this.created_at = res.data.data.advertisement.created_at
                    this.user_name = res.data.data.advertisement.user_name,
                    this.product_source = res.data.data.advertisement.product_source,
                    this.rank = res.data.data.advertisement.rank,
                    this.coupon_amount = res.data.data.advertisement.coupon_amount,
                    this.price = res.data.data.advertisement.price,
                    this.final_price = res.data.data.advertisement.final_price
                    this.frequency = res.data.data.advertisement.frequency
                    this.duration = res.data.data.advertisement.duration
                    this.order_flow_flag = res.data.data.advertisement.order_flow_flag
                    this.vip_flow_flag = res.data.data.advertisement.vip_flow_flag
                    this.ad_content_type = res.data.data.advertisement.ad_content_type
                    if (this.source == '文案弹窗广告') {
                        this.buttons = res.data.data.advertisement.buttons
                    }
                }
            })
        },
        handleUpload(){},
        handleFormatError(){}
    },
    created() {
        Cookies.set('active_name', '2');
        this.ad_id = this.$route.query.ad_id
        this.getAdDetail(this.ad_id)
    },
};
</script>
<style scoped>
.row{
  margin: 20px;
  max-width:500px
}
.col1{
    color: rgba(71,86,99,.8);
    padding: 0 16px;
    text-indent: 0.7em;
    margin-right: 30px;
    white-space: nowrap;
    text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/views/Ad/AdDetail.vue